module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    ref: "header",
    attrs: {
      "name": "topHeader"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "swipe"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "swipeList"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "homePage0"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "homePage1"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "homePage2"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "aps"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "ac1"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "ac2"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "ac3"
    }
  }), _vm._v(" "), _c('router-view', {
    ref: "openapi",
    attrs: {
      "name": "open"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "shareContent"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "aboutContent"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "downloadContent"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "jobContent"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "login"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "backend"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "footer"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "simpleFooter"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearFloat"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20c9d6e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 326
// module chunks = 1